var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    ref: "editor",
    staticStyle: {
      "text-align": "left",
      "background-color": "#ffffff"
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.$t('sc.gallery.pickerImageDialogTitle'),
      "visible": _vm.showGalleryPicker,
      "width": "960px",
      "append-to-body": "",
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function ($event) {
        _vm.showGalleryPicker = $event;
      }
    }
  }, [_vm.showGalleryPicker ? _c('GalleryPicker', {
    attrs: {
      "mode": "picker",
      "default-file-type": "image",
      "multiple": true,
      "max-select": _vm.galleryMaxDetailPick
    },
    on: {
      "select": _vm.handleEditorGallerySelect,
      "close": function ($event) {
        _vm.showGalleryPicker = false;
      }
    }
  }) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }